import { useMyHrContract, useMyHrEmployee } from "my-hr/hooks";
import { useMyTimesheetTimesheetList } from "my-timesheet/hooks";

type UseMyTimesheetRequestsByContractProps = {
  contract: string;
  periodStart: Date;
  periodEnd: Date;
  showOnlyRequests?: boolean;
};

export const useMyTimesheetRequestsByContract = ({
  contract,
  periodStart,
  periodEnd,
  showOnlyRequests,
}: UseMyTimesheetRequestsByContractProps) => {
  const { data: contractData } = useMyHrContract({
    contract: contract,
  });

  const employeeId = contractData?.employee?.code;

  const { data: employeeData } = useMyHrEmployee({
    employeeId: employeeId,
  });

  const { data, loading, error } = useMyTimesheetTimesheetList({
    contractId: contract,
    periodStart: periodStart,
    periodEnd: periodEnd,
    showOnlyRequests: showOnlyRequests,
    role: "user",
  });

  return { contractData, employeeData, data, loading, error };
};

export default useMyTimesheetRequestsByContract;
